export const UserRoles = {
  Admin: 'admin',
  SuperAdmin: 'superAdmin',
  Member: 'member',
};
